import { supabase } from "./supabaseClient";

export function getBackendUrl() {
  if (process.env.REACT_APP_BACKEND_URL) {
    return process.env.REACT_APP_BACKEND_URL.replace(/\/$/, "");
  }
  if (typeof window !== "undefined" && window.location) {
    const { protocol, hostname, port } = window.location;
    if (hostname !== "localhost" && hostname !== "127.0.0.1") {
      if (port === "3000") {
        return `${protocol}//${hostname}:8000`;
      }
      return window.location.origin;
    }
  }
  return "http://localhost:8000";
}

// Send session credentials only to our backend, never to external file URLs.
export async function apiFetch(input, options = {}) {
  const backendUrl = getBackendUrl();
  let resolvedInput = input;
  if (typeof resolvedInput === "string") {
    if (resolvedInput.startsWith("/api/")) {
      resolvedInput = `${backendUrl}${resolvedInput}`;
    } else if (backendUrl && backendUrl !== "http://localhost:8000") {
      resolvedInput = resolvedInput.replace(/^https?:\/\/(?:localhost|127\.0\.0\.1):8000/i, backendUrl);
    }
  }
  const url = new URL(resolvedInput, window.location.origin);
  const backend = new URL(backendUrl);
  const ocrOrigin = new URL(process.env.REACT_APP_OCR_ENDPOINT || backend.href).origin;
  if (url.origin !== backend.origin && url.origin !== ocrOrigin) return fetch(resolvedInput, options);
  const { data, error } = await supabase.auth.getSession();
  if (error) throw error;
  const headers = new Headers(options.headers);
  if (data?.session?.access_token) headers.set("Authorization", `Bearer ${data.session.access_token}`);
  return fetch(resolvedInput, { ...options, headers });
}

export async function adminRequest(path, options = {}) {
  const backend = getBackendUrl();
  let response;
  try {
    response = await apiFetch(`${backend}/api/admin/${path}`, options);
  } catch (error) {
    if (error instanceof TypeError) throw new Error(`Cannot reach the backend at ${backend}. Start it with npm run start:backend, then click Refresh.`);
    throw error;
  }
  const body = await response.json();
  if (!response.ok) throw new Error(typeof body.detail === "string" ? body.detail : "Unable to complete the request.");
  return body;
}
